import { FilterGroupingEnum } from 'graphql-common';

interface Predicate {
  cont?: string;
  contAny?: string[];
  eq?: string;
}

export interface Filter {
  [k: string]: {
    grouping: FilterGroupingEnum;
    predicate: Predicate;
    filterGroup?: string;
  };
}

export enum FilterSchemaPredicateType {
  Cont = 'cont',
  Eq = 'eq',
}

export interface FilterSchema {
  fieldName: string;
  predicateType?: FilterSchemaPredicateType;
  filterGroup?: string;
}

export const defaultSearchListSchema = [{ fieldName: 'name' }];

export default function createSearchFilters(
  searchQuery: string | null,
  schema: FilterSchema[],
): Filter[] {
  const filters: Filter[] = [];

  if (searchQuery) {
    const words = searchQuery
      .split(' ')
      .map((w) => w.trim())
      .filter((w) => w.length > 0);

    words.forEach((word, wordIndex) => {
      const filterGroup = `searchQuery-${wordIndex + 1}`;

      schema.forEach(
        ({ fieldName, predicateType = FilterSchemaPredicateType.Cont }) => {
          if (fieldName && predicateType) {
            const predicate: Predicate = {};
            predicate[predicateType] = word;

            const filter: Filter = {
              [fieldName]: {
                grouping: FilterGroupingEnum.Or,
                predicate,
                filterGroup,
              },
            };

            filters.push(filter);
          }
        },
      );
    });
  }

  return filters;
}
